export default __webpack_public_path__ + "static/media/45k.9d5df562.md";